import React from 'react'
import { Breadcrumbs } from '../breadcrumbs'
import { UserNav } from './user-nav'
import { NotificationsDropdown } from './notifications-dropdown'

const Header: React.FC = () => {
  return (
    <header className='flex h-14 shrink-0 items-center justify-between gap-2 border border-b transition-[width,height] ease-linear group-has-[[data-collapsible=icon]]/sidebar-wrapper:h-12'>
      <div className='flex items-center gap-2 px-4'>
        <Breadcrumbs />
      </div>

      <div className='flex items-center gap-2 px-4' id='map'>
        <NotificationsDropdown />
        <UserNav />
      </div>
    </header>
  )
}

export default Header